const types = {
  //Get Template name
  GET_METHOD_PACKAGES_START: "GET_METHOD_PACKAGES_START",
  GET_METHOD_PACKAGES_SUCCESS: "GET_METHOD_PACKAGES_SUCCESS",
  GET_METHOD_PACKAGES_ERROR: "GET_METHOD_PACKAGES_ERROR",
  GET_METHOD_PACKAGES_RESET: "GET_METHOD_PACKAGES_RESET",

  //Create Template name
  CREATE_METHOD_PACKAGES_START: "CREATE_METHOD_PACKAGES_START",
  CREATE_METHOD_PACKAGES_SUCCESS: "CREATE_METHOD_PACKAGES_SUCCESS",
  CREATE_METHOD_PACKAGES_ERROR: "CREATE_METHOD_PACKAGES_ERROR",
  CREATE_METHOD_PACKAGES_RESET: "CREATE_METHOD_PACKAGES_RESET",

  //delete Template name
  DELETE_METHOD_PACKAGES_START: "DELETE_METHOD_PACKAGES_START",
  DELETE_METHOD_PACKAGES_SUCCESS: "DELETE_METHOD_PACKAGES_SUCCESS",
  DELETE_METHOD_PACKAGES_ERROR: "DELETE_METHOD_PACKAGES_ERROR",
  DELETE_METHOD_PACKAGES_RESET: "DELETE_METHOD_PACKAGES_RESET",

  //update Template name
  UPDATE_METHOD_PACKAGES_START: "UPDATE_METHOD_PACKAGES_START",
  UPDATE_METHOD_PACKAGES_SUCCESS: "UPDATE_METHOD_PACKAGES_SUCCESS",
  UPDATE_METHOD_PACKAGES_ERROR: "UPDATE_METHOD_PACKAGES_ERROR",
  UPDATE_METHOD_PACKAGES_RESET: "UPDATE_METHOD_PACKAGES_RESET",

  //single item  name
  SINGLE_METHOD_PACKAGES_START: "SINGLE_METHOD_PACKAGES_START",
  SINGLE_METHOD_PACKAGES_SUCCESS: "SINGLE_METHOD_PACKAGES_SUCCESS",
  SINGLE_METHOD_PACKAGES_ERROR: "SINGLE_METHOD_PACKAGES_ERROR",
  SINGLE_METHOD_PACKAGES_RESET: "SINGLE_METHOD_PACKAGES_RESET",

  //single item  name
  METHOD_PACKAGES_FORM_START: "METHOD_PACKAGES_FORM_START",
  METHOD_PACKAGES_FORM_SUCCESS: "METHOD_PACKAGES_FORM_SUCCESS",
  METHOD_PACKAGES_FORM_ERROR: "METHOD_PACKAGES_FORM_ERROR",
  METHOD_PACKAGES_FORM_RESET: "METHOD_PACKAGES_FORM_RESET",

  METHOD_PACKAGES_FORM_EDIT_START: "METHOD_PACKAGES_FORM_EDIT_START",
  METHOD_PACKAGES_FORM_EDIT_SUCCESS: "METHOD_PACKAGES_FORM_EDIT_SUCCESS",
  METHOD_PACKAGES_FORM_EDIT_ERROR: "METHOD_PACKAGES_FORM_EDIT_ERROR",
  METHOD_PACKAGES_FORM_EDIT_RESET: "METHOD_PACKAGES_FORM_EDIT_RESET",
};

export default types;
